<template>
	<li :class="['text-xs', isVisible ? 'opacity-100' : 'opacity-0', 'transition-opacity duration-1000 ease-in-out', { 'hidden': isHidden }]">
		<span
			v-if="isValid"
			class="text-green-500"
		>
			&#x2714;
		</span>
		<span
			v-else
			class="text-mx-red"
		>
			&#x274c;
		</span>
		{{ text }}
	</li>
</template>

<script setup lang="ts">
const props = defineProps({
	text: {
		type: String,
		default: ''
	},
	isValid: {
		type: Boolean,
		default: false
	}
})

const { isValid } = toRefs(props)

const isVisible = ref(true)
const isHidden = ref(false)
const timeout = ref<ReturnType<typeof setTimeout> | null>(null)

watch(isValid, (val) => {
	if (!val) {
		if (timeout.value) {
			clearTimeout(timeout.value)
		}
		isVisible.value = true
		isHidden.value = false
	} else {
		isVisible.value = false
		timeout.value = setTimeout(() => {
			isHidden.value = true
		}, 1000)
	}
}, { immediate: true })
</script>
